export default "__VITE_ASSET__DXkjNi5P__"